module.exports = __webpack_public_path__ + "img/jigsawPuzzle_3.32a1787b.png";